<template>
  <div
    class="grid grid-cols-2 md:grid-cols-4 gap-5"
    v-if="images.length"
    ref="gallery"
  >
    <div v-for="image in images" :key="image.id">
      <a :href="image.largeFileUrl" class="gallery-item">
        <img
          :src="image.smallFileUrl"
          :alt="image.caption"
          class="rounded-md"
        />
      </a>
    </div>
  </div>
</template>
<script>
import 'lightgallery.js';
export default {
  name: 'GalleryImageGrid',
  props: {
    images: {
      type: Array,
      required: true,
    },
    options: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  mounted() {
    window.lightGallery(this.$refs.gallery, {
      ...{ selector: '.gallery-item' },
      ...this.options,
    });
  },
};
</script>
